import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const ContactSheme = Yup.object().shape({
  name: Yup.string().required(),
  islm_id: Yup.number().required(),
  email: Yup.string().required().email(),
  telefonIsValid: Yup.boolean().isTrue(),
});
